import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  API_GET_ACCESS_TOKEN_URL,
  APIGetAccessTokenType,
} from "../../services/APIAuthorizationService";
import { APICall, UNAUTHORIZED } from "../../services/APIService";
import { useUserData } from "../../context/UserDataContext";

const Callback = () => {
  useEffect(() => {
    exchangeToken();
  }, []);

  const navigate = useNavigate();

  const location = useLocation();
  const response = location.state; // The original login response JSON

  const { setRowPolicies } = useUserData()

  //console.log("Received in callback:", response);

  // Exchange token
  /* const exchangeToken = async () => {
    const token = localStorage.getItem("access_token");
    if (token) {
      //window.localStorage.setItem("accessToken", response.data.accessToken)
      //window.location.href = "/";
      navigate('/', { state: response });
      sessionStorage.setItem("user", JSON.stringify(response));
    } else if (!token) {
      console.log("authorization failed");
    } else {
      console.log("login error");
    }
  }; */

  const exchangeToken = async () => {
    const token = localStorage.getItem("access_token");

    // No token case
    if (!token) {
      console.log("authorization failed");
      navigate("/login");
      return;
    }

    try {
      // Save user data
      sessionStorage.setItem("user", JSON.stringify(response));
      const polices: string = response.policies
      const policyList: string[] = polices.split(",").map(item => item.trim())
      setRowPolicies(policyList)
      // const savedUser = sessionStorage.getItem("user");

      // if (!savedUser) {
      //   throw new Error("User data not saved");
      // }

      // const parsedUser = JSON.parse(savedUser);
      // const userPolicies = parsedUser.policies
      //   .split(",")
      //   .map((p: string) => p.trim());

      // Determine target route based on policies
      //let targetRoute = "/restricted"; // Default route
      let targetRoute = "/"; // Default route

      // if (userPolicies.includes("Workflow Manage")) {
      //   targetRoute = "/";
      // } else if (userPolicies.includes("Organization Manage")) {
      //   targetRoute = "/back_office_system/create_organization";
      // } else if (userPolicies.includes("Department Manage")) {
      //   targetRoute = "/back_office_system/department";
      // }

      // try {
      //   await refetch();
      // } catch (refetchError) {
      //     console.error('Refetch failed:', refetchError);
      // }

      // if (hasPolicy("WORKFLOW_MANAGE")) {
      //     targetRoute = "/";
      //   } else if (hasPolicy("ORGANIZATION_MANAGE")) {
      //     targetRoute = "/back_office_system/create_organization";
      //   } else if (hasPolicy("DEPARTMENT_MANAGE")) {
      //     targetRoute = "/back_office_system/department";
      //   }

      // Navigate with the response state
      navigate(targetRoute, { state: response });
    } catch (error) {
      console.error("Login error:", error);
      navigate("/error");
    }
  };

  return (
    <div
      style={{
        backgroundColor: "black",
        width: "100vw",
        height: "100vh",
        color: "white",
      }}
    >
      logging..........
    </div>
  );
};

export default Callback;
